import Udesk from 'Udesk';
import React, { FC, memo } from 'react';
import { ReportEcharts } from 'udesk-react/src/components/report/report-echarts';
import styled from 'styled-components';

const Wrapper = styled.div`
    height: 280px;
    background: #ffffff;
    border-radius: 2px;
    padding: 16px;
    display: flex;

    .operational-tatistics-box-average-item {
        flex: 1;
    }

    .operational-tatistics-box-content {
        height: calc(100% - 22px);
    }
`;

interface TemplateProps {
    sdkOptions: any;
    chartDataParams?: Record<string, unknown>;
}

const Template: FC<TemplateProps> = memo((props) => {
    let { sdkOptions, chartDataParams } = props;

    const chartDataUrl = Udesk.business.apiPath.concatApiPath(
        `inspectionVocHomePage/queryLatestDataStatic`,
        sdkOptions
    );

    const onSeriesClicked = (e) => {
        console.log(e);
    };

    return (
        <Wrapper>
            <div className="operational-tatistics-box-average-item">
                <div className="operational-tatistics-box-content">
                    <ReportEcharts
                        chartTitle={''}
                        chartType={Udesk.enums.echartTypes.line}
                        chartDataUrl={chartDataUrl}
                        chartDataParams={chartDataParams}
                        sdkOptions={sdkOptions}
                        chartConfigOptions={{
                            finalizeChartOptions: (options) => {
                                console.log(options, 'options');

                                options.grid.top = 40;
                                options.grid.bottom = 10;

                                return options;
                            },
                        }}
                        onSeriesClicked={onSeriesClicked}
                    />
                </div>
            </div>
        </Wrapper>
    );
});

export default Template;
